import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';

const BUBBLE_VISIBLE_MS = 5000;
const BUBBLE_INTERVAL_MS = 18000;
const FIRST_BUBBLE_DELAY_MS = 2500;

const WhatsAppButton = () => {
  const [showBubble, setShowBubble] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return undefined;

    let hideTimeout;
    const runCycle = () => {
      setShowBubble(true);
      hideTimeout = setTimeout(() => setShowBubble(false), BUBBLE_VISIBLE_MS);
    };

    const firstShow = setTimeout(runCycle, FIRST_BUBBLE_DELAY_MS);
    const interval = setInterval(runCycle, BUBBLE_INTERVAL_MS);

    return () => {
      clearTimeout(firstShow);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, [dismissed]);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-end gap-3">
      <AnimatePresence>
        {showBubble && !dismissed && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.9 }}
            transition={{ type: 'spring', stiffness: 300, damping: 22 }}
            className="relative bg-white text-coffee rounded-2xl rounded-br-sm shadow-2xl px-4 py-3 max-w-[220px] mb-1"
            data-testid="whatsapp-bubble"
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowBubble(false);
                setDismissed(true);
              }}
              className="absolute -top-2 -right-2 bg-coffee text-white rounded-full p-1 shadow-md hover:bg-coffee-light transition-colors"
              aria-label="Cerrar mensaje"
              data-testid="whatsapp-bubble-close"
            >
              <X className="w-3 h-3" />
            </button>
            <p className="text-sm font-medium leading-snug">
              ¿Pedidos o reservas? <span className="text-terracotta">¡Escríbenos!</span> 🙋
            </p>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.a
        href="https://wa.me/34623513773?text=Hola,%20me%20gustaría%20hacer%20una%20consulta"
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: 'spring', stiffness: 200 }}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 animate-pulse-glow shrink-0"
        data-testid="whatsapp-float-btn"
        aria-label="Contactar por WhatsApp"
      >
        <MessageCircle className="w-7 h-7" />
      </motion.a>
    </div>
  );
};

export default WhatsAppButton;
